import { CONF_API_URL } from 'utils/config';
import storage from 'utils/storage';

const join = (b: string, p: string) => `${b.replace(/\/+$/, '')}/${p.replace(/^\/+/, '')}`;

export async function apiFetch<TResponse>(
  path: string,
  init: RequestInit = {}
): Promise<TResponse> {
  const url = /^https?:\/\//i.test(path) ? path : join(CONF_API_URL, path);

  const token = (storage.getItem('token') ?? '')
    .toString()
    .replace(/^"+|"+$/g, '')
    .trim();

  const isForm = typeof FormData !== 'undefined' && init.body instanceof FormData;
  const headers = new Headers(init.headers);

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (!isForm && !headers.has('Content-Type') && init.method && init.method !== 'GET') {
    headers.set('Content-Type', 'application/json');
  }

  const body =
    init.body && !isForm && typeof init.body === 'object' ? JSON.stringify(init.body) : init.body;

  const res = await fetch(url, { ...init, headers, body });

  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const err = await res.json();
      message = err?.message || message;
    } catch {}
    throw new Error(message);
  }

  if (res.status === 204) return {} as TResponse;

  const text = await res.text();
  if (!text) return {} as TResponse;

  try {
    return JSON.parse(text) as TResponse;
  } catch {
    return text as unknown as TResponse;
  }
}
